export default "__VITE_ASSET__D$zbJQYX__"